exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".aje92RGTm73GBRJxS6ExW{text-align:center;font-style:italic;color:#666}\n", ""]);

// Exports
exports.locals = {
	"caption": "aje92RGTm73GBRJxS6ExW"
};